import { render, staticRenderFns } from "./IpoDetail.vue?vue&type=template&id=70c0eef6"
import script from "./IpoDetail.vue?vue&type=script&lang=js"
export * from "./IpoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports